import { render, staticRenderFns } from "./SliderChoice.vue?vue&type=template&id=745da24b&scoped=true&"
import script from "./SliderChoice.vue?vue&type=script&lang=js&"
export * from "./SliderChoice.vue?vue&type=script&lang=js&"
import style0 from "./SliderChoice.vue?vue&type=style&index=0&id=745da24b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745da24b",
  null
  
)

export default component.exports